import { Component, OnInit } from '@angular/core';
import { NavBarService } from '../../../services/nav-bar.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { TranslationService } from '../../../services/translation.service';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { Helper, MenuNode } from '../../../classes';

import { EnabledNodesPipe } from '../../../pipes/enabled-nodes.pipe';

@Component({
  selector: 'app-scale-list',
  templateUrl: './scale-list.component.html',
  styleUrls: ['./scale-list.component.scss']
})
export class ScaleListComponent implements OnInit {
	node : MenuNode = undefined;
  currentElement : MenuNode = undefined;
  menuElements : Array<MenuNode> = undefined;
  _s : string="";
  _b: string="";
  _unit:string="";
  _gated:boolean=false;
  constructor(
  	private navBar:NavBarService,
  	private iconBar:IconBarService,
  	private menuService:MenuService,
  	private ioService:DataIoService,
    private enabledNodes: EnabledNodesPipe,
    private translator: TranslationService
    ) { }
  b():string{
    if(this._autoScrollHandle){
      return this._autoScroll_B;
    }
    //return this.bigLetters;
    return this._b;
  }
  unit():string{
  	return this._unit;
  }
  s():string{
    if(this._autoScrollHandle){
      return this._autoScroll_S;
    }
    
    return this._s;
  }
  getCurrentIndex():number{
    return this.menuElements.indexOf(this.currentElement);
  }
  next():void{

    let idx = this.getCurrentIndex();
    let length = this.menuElements.length;
    idx++
    if(idx >= length){
      idx = 0;
    }
    while(!this.menuElements[idx].isEnabled()){
      idx++;
      if(idx >= length){
        idx = 0;
      }
    }
    this.setCurrentElement(this.menuElements[idx]);    
  }
  previous():void{
    let idx = this.getCurrentIndex();
    let length = this.menuElements.length;
    idx--;
    if(idx < 0){
      idx = (length-1);
    }
    while(!this.menuElements[idx].isEnabled()){
      idx--;
      if(idx < 0){
        idx = (length-1);
      }
    }
    this.setCurrentElement(this.menuElements[(idx++)%length]);
  }








  handler(evt){
  	switch(evt){
  		case 'menu':{
        if(this.node.getIdentifier() == 'chimneysweepmode'){
          console.log("Trying to go to fachhandwerker-codeabfrage");
          this.menuService.goto('fachhandwerker-codeabfrage');
          console.log("going?!");
        }
        return;
      }
      case 'confirm':{
        if(this._gated){
          this.menuService.goto(this.node.getTargetNode());
          if(this.node.getIdentifier() == 'chimneysweepmode'){
            this.iconBar.disable();
            this.navBar.disableAll();
            this.navBar.enable('chimneysweep');
          }
          return;
        }
        this.currentElement.selected = "true"
        this.menuService.goto(this.currentElement.getTargetNode());
        return;
      }
      case 'up':{
        this.next();
        return;
      }
      case 'down':{
        this.previous();
        return;
      }
      case 'back':{
        console.log("Running deselection.");
        this.currentElement.selected = "false";
        let backTarget = this.node.getBackTargetNode();
        if(backTarget){
          this.menuService.goto(backTarget);
        }else{
        	this.menuService.hierarchyUp(true,undefined);
        }
        return;
      }
      default:{
        return;
      }
    }
  }




  hasParameter(p:string):boolean{
  	if(this.node){
  		return this.node.hasParameter(p);
  	}
  	return false;
  }
  subscription:any=undefined;
  ngOnDestroy(){
    this.customDestroy();
  }
  elements = Array<MenuNode>();

  ngOnInit() {
    this.node = this.menuService.getCurrentNode();
    this.iconBar.saveState('onMenuInit');
    this.getMenuItems();
    this.findSelected();
    this.subscription = this.ioService.inputs.events$.subscribe( (evt)=>{
      this.handler(evt);
    });
    
  }
  findSelected(){
    let selected = null;

    for(let el of this.menuElements){
      if(el.isSelected()){
        selected = el;
        if(el.selected == 'true'){
          el.selected = '';
        }
      }
      for(let subEl of el.getChilds()){
        if(subEl.isSelected()){
          selected = subEl;
          if(subEl.selected == 'true'){
            subEl.selected = '';
          }
        }
      }
    }
    if(selected != null){
      this.setCurrentElement(selected);
    }
  }
  customDestroy(){
    //this.debug("#### OnDestroy, unsubscribing.");
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    this.stopAutoscroll();
    //this.debug("#### OnDestroy, unsubscribed.");
    this.subscription = null;
    this.node.run((node)=>node.removeFilter(this.node.getTitle()),3);
  }

  getMenuItems():void{
    var _this = this;
    this.node.run(function (node) { return node.setFilter(_this.node.getTitle(), _this.enabledNodes.transform); }, 3);
    this.menuElements = this.node.getChilds().filter( (x) => x.isEnabled() );
    this.setCurrentElement(this.node.getChildByIndex(0));
  }


  setDiagnoseCodeContent(){
  	let elementTitle = this.currentElement.getTitle();
  	let code = elementTitle.split('\n')[0].toLowerCase();
  	this._s = code;
  	let b : string = undefined;
  	let scale = this.ioService.deviceInfo().getScale(code.replace('.',''));
  	if(scale){
      if(scale.isList()){
        let tr = this.translator.tr(scale.getCurrentElement(),'en');
        if(tr === undefined){
          b = ""+scale.getCurrentElement();
        }else{
          b = ""+tr;
          if(scale.hasSpecialValue(scale.getCurrentValue())){
            b = scale.getSpecialValue(scale.getCurrentValue()).getReplacement()+"";
          }
        }
      }else{
        b = ""+scale.getCurrentValue();
        if(scale.hasSpecialValue(scale.getCurrentValue())){
            b = scale.getSpecialValue(scale.getCurrentValue()).getReplacement()+"";
          }
      }
    }
    this._b = b;
    if( Number.isNaN( Number.parseFloat(b)) ){
      this._unit = '';
    }else{
      this._unit = scale.getRawUnit();
    }

    if(this.currentElement.getChilds().length == 0){
      console.log("disabling button.");
      this.menuService.disableButton('confirm');
    }else{
      console.log("Undisabling button.");
      this.menuService.undisableButton('confirm');
    }
  }
  _autoScrollHandle=undefined;
  _autoScroll_B=undefined;
  _autoScroll_S=undefined;
  _autoScroll_Align=undefined;

  autoScroll(){
    let scale = undefined;
    if(this.currentElement.getIdentifier() && this.currentElement.getIdentifier().startsWith('diagnoseCode')){
      let code = this.currentElement.getTitle().split('\n')[0].toLowerCase();
      scale = this.ioService.deviceInfo().getScale(code.replace('.',''));
    }
    this._autoScrollIdx = 0;
    console.log("Starting autoscroll.");
    //this.intervalFn(scale);
    if(this.currentElement.getIdentifier()=='diagnoseCode.095'){
      this._autoScroll_S = 'd.095';
    }
    this._autoScrollHandle = setInterval(
      ()=>
      {
        this.intervalFn(scale);
      }
      ,1500);
  }
  _autoScrollIdx = undefined;
  intervalFn(scale?){
    console.log("IntervalFunction for "+this.currentElement.getIdentifier());
    if(this.currentElement.getIdentifier() == 'diagnoseCode.161'){
      this._autoScroll_S = 'd.161';
      let sd = this.ioService.getServiceDate();
      switch(this._autoScrollIdx){
        case undefined:
        case 0:{
          this._autoScrollIdx = 1;
          this._autoScroll_B = Helper.twoDigits(sd.getDate())+'.'+Helper.twoDigits((sd.getMonth()+1));
          return;
        }
        case 1:{
          this._autoScrollIdx = 0;
          this._autoScroll_B = sd.getFullYear();
          return;
        }
        default:
        {
          console.log("Undefined autoScrollidx: "+this._autoScrollIdx);
        }
      }
      return;
    }

    // 
    if(this.currentElement.getIdentifier()=='diagnoseCode.095'){
      let parts = scale.getCurrentElement().split('.');
      if(this._autoScrollIdx === undefined){
        this._autoScrollIdx = 0;
      }else{
        this._autoScrollIdx++;
      }

      let max = scale.getMaxValue()+1;
      if(this._autoScrollIdx == parts.length){
        console.log("Overflowing.");
        this._autoScrollIdx = 0;
        let curVal = scale.getCurrentValue();
        curVal++;
        if(curVal > scale.getMaxValue()){
          curVal = 0;
        }
        scale.setCurrentValue(curVal);
        parts = scale.getCurrentElement().split('.');
      }
      if(this._autoScrollIdx == 1){
        this._autoScroll_Align = 'left';
      }else{
        this._autoScroll_Align = 'right';
      }

      this._autoScroll_S = (scale.getCurrentValue()+1)+"'"+max;
      this._autoScroll_B = parts[this._autoScrollIdx];
      return;
    }
  }
  alignment(){
    if(this._autoScrollHandle){
      return this._autoScroll_Align;
    }
    return 'right';
  }
  stopAutoscroll(){
    if(this._autoScrollHandle){
      clearInterval(this._autoScrollHandle);
      this._autoScrollHandle = undefined;
      this._autoScroll_S = undefined;
      this._autoScroll_B = undefined;
      this._autoScroll_Align = undefined;
      this._autoScrollIdx = undefined;
    }
  }
  setCurrentElement(node:MenuNode){
    if(this.currentElement){
      this.currentElement.selected = "false";
    }
    node.selected = "true";
    this.stopAutoscroll();
    this.currentElement = node;
    this.iconBar.disableAll();
    if(this.currentElement.getIdentifier() && this.currentElement.getIdentifier().startsWith('diagnoseCode')){
      this.setDiagnoseCodeContent();
      this.ioService.infoTextAvailable(this.currentElement);
    }
    if(node.hasParameter('autoScroll')){
      console.log("Node has autoscroll-parameter.");
      this.autoScroll();
    }
    let icon = this.currentElement.getIcon();
    if( (![null,undefined,''].includes(icon)) && this.iconBar.knowsOf(icon) ){
      console.warn("Icon found. Enabling icon '"+icon+"'");
      this.iconBar.enableIcon(icon);
    }else{
      console.log("Iconbar does not know of icon "+icon);
    }

  }
}
